// extracted by mini-css-extract-plugin
export default {"container":"BaseLayout_container__mFQOe"};